enum DataExplorerFilterPropertyListDataControllersEnum {
    TaxFilters = 'Tax Filters',
}

export default DataExplorerFilterPropertyListDataControllersEnum;
